import {useCallback} from "react";
import {useAppContext} from "@/context/app";
import useCompanyApi from "@/hooks/useCompanyApi.ts";
import useSupportApi from "@/hooks/useSupportApi.ts";
import useChannelApi from "@/hooks/useChannelApi.ts";

type UseLoadDataHook = {
    loadData: () => Promise<void>,
}
const useLoadData = (): UseLoadDataHook => {

    const {loaded, setLoaded, setCompany, setChannels, setCompletedSupport, auth} = useAppContext()
    const {getCompany} = useCompanyApi()
    const {getSupportStatus} = useSupportApi()
    const {getChannels} = useChannelApi()

    const token = auth.user?.token

    const loadData = useCallback((): Promise<void> => {
        return new Promise((resolve, reject) => {
            if (token && !loaded) {
                const company = loadCompany()
                const completedSupport = loadSupportStatus()
                const channels = loadChannels()
                Promise.all([company, completedSupport, channels]).then(() => {
                    setLoaded(true)
                    resolve()
                }).catch((err) => reject(err))
            }
        })

    }, [token, loaded])


    const loadCompany = useCallback((): Promise<void> => {
        return new Promise((resolve, reject) => {
            getCompany().then((r) => {
                setCompany(r)
                resolve()
            }).catch((err) => reject(err))
        })
    }, [token, loaded])

    const loadSupportStatus = useCallback((): Promise<void> => {
        return new Promise((resolve, reject) => {
            getSupportStatus().then((r) => {
                setCompletedSupport(r)
                resolve()
            }).catch((err) => reject(err))
        })
    }, [token, loaded])

    const loadChannels = useCallback((): Promise<void> => {
        return new Promise((resolve, reject) => {
            getChannels().then((r) => {
                setChannels(r)
                resolve()
            }).catch((err) => reject(err))
        })
    }, [token, loaded])

    return {
        loadData
    };
};

export default useLoadData;
